module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 5
// module chunks = 0